import { Component, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { first } from 'rxjs/operators';
import { ITimeEntryCategory } from '../models/time-entry-category';
import { TimeEntryCategoryService } from '../services/time-entry-category.service';
import { sortAscSmallIcon, sortDescSmallIcon } from '@progress/kendo-svg-icons';

@Component({
    selector: 'app-time-entry-category',
    templateUrl: './time-entry-category.component.html',
    styleUrls: ['./time-entry-category.component.css'],
    standalone: false
})
export class TimeEntryCategoryComponent implements OnInit {

  constructor(
    private route : ActivatedRoute,
    private timeEntryCategoryService: TimeEntryCategoryService
  ) { }
    
  timeEntryCategories: ITimeEntryCategory[] = [];
  public formGroup!: UntypedFormGroup;
  private editedRowIndex!: number;

    //icons
  public icons  = {
    sortAsc: sortAscSmallIcon,
    sortDesc: sortDescSmallIcon
  };

  ngOnInit(): void {
    this.timeEntryCategories = this.route.snapshot.data.timeEntryCategories as ITimeEntryCategory[];
  }

  updateList(){
    this.timeEntryCategoryService.searchTimeEntryCategories({pageNumber: 0, pageSize: 999999})
    .pipe(first())
    .subscribe(response => {
      this.timeEntryCategories = response.data;
    })
  }

  addHandler({ sender }){
    this.closeEditor(sender);

    this.formGroup = new UntypedFormGroup({
      name: new UntypedFormControl(null, Validators.required),
      isProductive: new UntypedFormControl(false),
      color: new UntypedFormControl(null, Validators.required),
    });

    sender.addRow(this.formGroup);
  }

  editHandler({ sender, rowIndex, dataItem }){
    this.closeEditor(sender);

    this.formGroup = new UntypedFormGroup({
      name: new UntypedFormControl(dataItem.name, Validators.required),
      isProductive: new UntypedFormControl(dataItem.isProductive),
      color: new UntypedFormControl(dataItem.color),
    });

    this.editedRowIndex = rowIndex;

    sender.editRow(rowIndex, this.formGroup);
  }

  public cancelHandler({ sender, rowIndex }) {
    this.closeEditor(sender, rowIndex);
  }

  public saveHandler(event) {
    const request: any = {
      name: event.formGroup.value.name,
      isProductive: event.formGroup.value.isProductive,
      color: event.formGroup.value.color,
      id: event.dataItem.id ?? null,
    }
    if (!event.dataItem.id){
      this.timeEntryCategoryService.createTimeEntryCategory(request)
      .subscribe(response => {
        this.updateList();
      });
    } else {
      this.timeEntryCategoryService.updateTimeEntryCategory(request)
      .subscribe(response => {
        this.updateList();
      });;
    }

    event.sender.closeRow(event.rowIndex);
    
  }

  private closeEditor(grid, rowIndex = this.editedRowIndex) {
    grid.closeRow(rowIndex);
    this.editedRowIndex = undefined;
    this.formGroup = undefined;
  }

  deletionDialogOpened = false;
  private itemToDelete: { id: string } | null = null;

  public removeHandler({ dataItem }) {
    this.itemToDelete = dataItem;
    this.deletionDialogOpened = true;
  }

  public deleteConfirmed() {
    const dataItem = this.itemToDelete;
    this.itemToDelete = null;
    if (!dataItem) return;
    this.timeEntryCategoryService.deleteTimeEntryCategory(dataItem.id)
    .subscribe(response => {
      this.updateList();
    });;
  }

  public onMoveUp(dataItem, index){
    const request: any = {
      ...dataItem,
      sortOrder: dataItem.sortOrder + 1,
    }
    this.timeEntryCategoryService.updateTimeEntryCategory(request)
      .subscribe(response => {
        this.updateList();
      });;
  }

  public onMoveDown(dataItem, index){
    const request: any = {
      ...dataItem,
      sortOrder: dataItem.sortOrder - 1,
    }
    this.timeEntryCategoryService.updateTimeEntryCategory(request)
      .subscribe(response => {
        this.updateList();
      });;
  }

}
